import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollTopOnRoute = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window) {
      window.scroll(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollTopOnRoute;
